import { CAMPAIGNS_API } from 'modules/campaigns/api/constants'
import { CampaignListItemInterface } from 'modules/campaigns/types/campaign-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'
import { useControlledSwr } from '@systemeio/util'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export function useCampaignsList(shouldFetch: boolean = true) {
  const { user } = useUser()

  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<CampaignListItemInterface>
  >({
    method: RequestMethodsEnum.get,
  })

  const { data: campaignsList } = useControlledSwr(
    () => {
      if (user && shouldFetch) {
        return [`${CAMPAIGNS_API}/list-all`, RequestModuleEnum.Campaign]
      }
    },
    fetcher,
    undefined,
    shouldFetch,
  )

  return { campaignsList }
}
